module.exports = __webpack_public_path__ + "media/media/logos/logo-58cf01f8084a6bb48881053742926428.svg";